import { render, staticRenderFns } from "./AddSupplementalMessage.vue?vue&type=template&id=23f98fe7&scoped=true&"
import script from "./AddSupplementalMessage.vue?vue&type=script&lang=js&"
export * from "./AddSupplementalMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplementalMessage.vue?vue&type=style&index=0&id=23f98fe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f98fe7",
  null
  
)

export default component.exports